export default __webpack_public_path__ + "static/media/jhcap.ac25bad8.jpg";